<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      Configure la aplicación con el nombre de su restaurante,<br />
      aquí
      <router-link to="/config" rel="noopener">Configuración</router-link>.
    </p>
    <br />
    <b-button class="is-primary" @click="goto('/servicio')">
      Registrar servicio</b-button
    >
    <b-button class="is-primary is-light" @click="goto('/estadisticas')"
      >Estadisticas</b-button
    >
    <a href="https://codigo.gestionhseq.com"
      ><b-button class="is-success is-light">Generar QR</b-button></a
    >
    <h3>Vínculos principales</h3>
    <ul>
      <li>
        <a href="https://gestionhseq.com" target="_blank" rel="noopener"
          >Página principal</a
        >
      </li>

      <li>
        <a href="https://cms.gestionhseq.com" target="_blank" rel="noopener"
          >Blog</a
        >
      </li>
      <li>
        <a
          href="https://gestionhseq.com/#contacto"
          target="_blank"
          rel="noopener"
          >contacto</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  methods: {
    goto: function (path) {
      this.$router.push(path);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
